/**
 * Height taken by the `AppShell` top bar above the content (0px when the sidebar is permanent).
 * Set on the shell root so full-height content (`PageLayout fixedHeader`) can subtract it.
 */
export const APP_SHELL_TOP_OFFSET_VAR = '--app-shell-top-offset';

export const APP_SHELL_TOP_OFFSET = `var(${APP_SHELL_TOP_OFFSET_VAR}, 0px)`;

/** Below this breakpoint the sidebar becomes a temporary drawer opened from the top bar. */
export const APP_SHELL_COMPACT_BREAKPOINT = 'md';
